import { PosBookmarkDetailPage } from '@/features/pos-bookmark/pages/PosBookmarkDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pos-bookmark/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pos_bookmark.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PosBookmarkDetailPage,
})
